import script from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"

import "./LinkDialog.vue?vue&type=style&index=0&id=03daa610&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03daa610"]])

export default __exports__